export class ZipCode {
  static isValid(zipCodeInput: string | null | undefined): boolean {
    return /^\d{8}$/.test(zipCodeInput);
  }
}
